<script setup lang="ts">
import InsuranceBanner from '@/components/ui/insurance/InsuranceBanner.vue'
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'
import { getInsurancePath } from '@/lib/insurance'
import type { BannerTab } from '@/lib/insurance'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

const props = defineProps<{
	pageContent: PageContent
}>()

const handleBannerTabClick = (tab: BannerTab) => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.ShoppingProtection,
		button_name: 'Parcel Forwarding',
	})

	window.location.href = getInsurancePath(tab)
}
</script>

<template>
	<InsuranceBanner
		:page-content="pageContent"
		theme="shopping"
		@banner-tab-click="handleBannerTabClick"
	/>
</template>
